import { ACCOUNTS_REDUCER_KEY } from './reducer';
import { AccountsStoreProps, AppAccountsState } from './type';

export const getAccountStore = (state: AppAccountsState): AccountsStoreProps => state[ACCOUNTS_REDUCER_KEY];

export const getInvestmentLoadPending = (state: AppAccountsState) => getAccountStore(state).isInvestmentAccountsLoading;

export const getAccountLoadPending = (state: AppAccountsState) => {
  const accountStore = getAccountStore(state);
  return accountStore.isInvestmentAccountsLoading && accountStore.isLoading && accountStore.loadPending;
};

